// extracted by mini-css-extract-plugin
module.exports = {"groupCube":"ShowGroupCube_groupCube__1RTaV"};